module.exports = {
  '': { value: '', code: 'N' },
  'left': { value: 'enum.hand.left', code: 'G' },
  'right': { value: 'enum.hand.right', code: 'D' }
}
